import { createContext, useContext, useState } from "react";

const MunicipalityContext = createContext<any>(null);

export const MunicipalityProvider = ({ children }: any) => {
  const [resetMunicipality, setResetMunicipality] = useState(false);

  return (
    <MunicipalityContext.Provider value={{ resetMunicipality, setResetMunicipality }}>
      {children}
    </MunicipalityContext.Provider>
  );
};

export const useMunicipality = () => useContext(MunicipalityContext);